// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__XjpbB","header":"MessagesList_header__3pJUZ","chat":"MessagesList_chat__2iU1d"};